var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default {
    root: function (_a) {
        var _b = _a.props, atMention = _b.atMention, color = _b.color, important = _b.important, timestamp = _b.timestamp, v = _a.variables;
        return __assign({}, (atMention === 'me' && {
            fontWeight: v.atMentionMeFontWeight,
        }), (timestamp && {
            ':hover': {
                color: v.timestampHoverColor,
            },
        }), (important && {
            fontWeight: v.importantWeight,
        }));
    },
};
